import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';

import clientStore from './stores/clientStore.js';
import { changeNetworkStatus } from 'actions/networkStatusActions';

const { dispatch } = clientStore;
if (ExecutionEnvironment.canUseDOM) {
	window.addEventListener('offline', () => {
		dispatch(changeNetworkStatus('OFFLINE'));
	});

	window.addEventListener('online', () => {
		dispatch(changeNetworkStatus('ONLINE'));
	});
}
